export function resolveAlertDisplayName(incidentOrAlert) {
  const labels = incidentOrAlert?.labels || {};
  const annotations = incidentOrAlert?.annotations || {};
  const alertname = String(
    incidentOrAlert?.alert_name || labels.alertname || "",
  ).trim();
  const rulename = String(labels.rulename || "").trim();
  const systemNames = new Set([
    "datasourceerror",
    "datasourcenodata",
    "executionerror",
  ]);

  for (const candidate of [
    annotations.clairai_alert_title,
    annotations.summary,
  ]) {
    const text = String(candidate || "").trim();
    if (text && !systemNames.has(text.toLowerCase()) && systemNames.has(alertname.toLowerCase())) {
      return text;
    }
  }

  if (systemNames.has(alertname.toLowerCase()) && rulename) {
    return rulename;
  }
  return alertname || rulename || "unknown";
}

const FIRING_STATES = new Set(["firing", "active", "error", "nodata"]);
const PENDING_STATES = new Set(["pending"]);

export function normalizeAlertEvaluationState(state) {
  const normalized = String(state || "").toLowerCase().trim();
  if (PENDING_STATES.has(normalized)) return "pending";
  if (FIRING_STATES.has(normalized)) return "firing";
  return normalized || "firing";
}

export function mergeAlertEvaluationStates(currentState, incomingState) {
  const current = normalizeAlertEvaluationState(currentState);
  const incoming = normalizeAlertEvaluationState(incomingState);
  if (current === "firing" || incoming === "firing") return "firing";
  if (current === "pending" || incoming === "pending") return "pending";
  return incoming;
}

export function alertStatusLabel(state) {
  const normalized = normalizeAlertEvaluationState(state);
  if (normalized === "pending") return "Pending";
  if (normalized === "firing") return "Firing";
  if (!normalized) return "Unknown";
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function alertStatusTagColor(state) {
  return normalizeAlertEvaluationState(state) === "pending" ? "orange" : "red";
}

export function isActionableHomeAlertState(state) {
  const normalized = String(state || "").toLowerCase().trim();
  return FIRING_STATES.has(normalized) || PENDING_STATES.has(normalized);
}

/** True for firing/active/error/nodata — excludes pending (dashboard "Firing alerts" widget). */
export function isFiringOnlyAlertState(state) {
  const normalized = String(state || "").toLowerCase().trim();
  return FIRING_STATES.has(normalized);
}
